export { default as Skeleton, type SkeletonProps } from './Skeleton';
